/* eslint-disable no-param-reassign */
import ls from "local-storage";

export class Checker {
  static check(permission) {
    const need = permission.split("|");
    const permissions = ls(process.env.VUE_APP_LS_PERMS) || [];
    let allowed = false;
    need.forEach(p => {
      if (permissions.indexOf(p) !== -1) {
        allowed = true;
      }
    });
    return allowed;
  }
}

const Acl = {
  install(Vue) {
    Vue.prototype.$can = permission => Checker.check(permission);
  }
};

export default Acl;
